<div class="w-100 h-100 d-flex align-items-center justify-content-center">
    <div class="empty-result-placeholder">
        <img src="assets/img/ai/global/empty-result.png" alt="Placeholder">
        <span class="fw-bold">Aucun résultat</span>
        <small class="italic">{{emptyMessage()}}</small>
        <div class="empty-result-placeholder__buttons">
            @if(options().showPageRefreshPossibility) {
            <span id="outline">
                <i-button [text]="'Recharger la page'" (click)="reloadPage()"></i-button>
            </span>
            }
            @if(options()?.retry && !options()?.callbackButton) {
            <i-button [text]="'Réessayer'" [styleClass]="'green'" (click)="options()?.retry()"></i-button>
            }@else if(options()?.callbackButton && !options()?.retry) {
            <i-button [text]="options()?.callbackButton?.text" [styleClass]="options()?.callbackButton?.styleClass"
                (click)="options()?.callbackButton?.click()"></i-button>
            }
        </div>
    </div>

</div>